/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".image-container[_ngcontent-%COMP%]{width:450;height:400px;overflow:auto;border:1px solid #ccc}.image-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:auto;height:auto}"];
export { styles as styles };
